import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/dashboard/rounded_artfield.png")